﻿window.LBSApp = window.LBSApp || {};
window.LBSApp.FocusUtils = {
    focusAndAdjust: function focusAndAdjust(element) {
        if (!element) {
            return;
        }
        element.setAttribute('tabindex', '-1');
        element.focus();
        element.addEventListener('blur', () => {
            element.removeAttribute('tabindex');
        }, { once: true });
        element.addEventListener('focusout', () => {
            element.removeAttribute('tabindex');
        }, { once: true });
    },

    initBackToTopButton: function initBackToTopButton() {
        const toTopButtonEl = document.querySelector('.js-Footer-totop');
        if (toTopButtonEl) {
            toTopButtonEl.addEventListener('click', evt => {
                const headerEl = document.querySelector('main h1');
                if (headerEl) {
                    window.LBSApp.FocusUtils.focusAndAdjust(headerEl);
                }
            });
        }
    }
}